import styled from "@emotion/styled";
import React from "react";
import UI from "@mile-meeting/mile-ui";

type DomainFieldProps = {
  domain: string;
};

const DomainField: React.FC<DomainFieldProps> = ({ domain }) => {
  return (
    <Container>
      <UI.Typography type="body01 normal" fontStyle="regular" color="var(--alias-color-label-normal)">
        @{domain}
      </UI.Typography>
    </Container>
  );
};

export default React.memo(DomainField);

const Container = styled.div`
  display: flex;
  padding: 12px 16px;
  align-items: center;
  align-self: stretch;
  box-sizing: border-box;

  border-bottom: 1px solid var(--alias-color-line-normal);
  background: var(--alias-color-background-normal-normal);
`;
